import React from 'react'

import './checkbox-tree-layout.scss'

import cn from '../../../../commons/src/libs/class-names'

import {CommonProps, Overwrite} from '../../../../commons/src/types'

type Props = Overwrite<
  CommonProps<'div'>,
  {
    header: React.ReactNode
    children?: React.ReactNode
  }
>

const CheckboxTreeLayout = ({className, header, children, ...props}: Props) => (
  <div {...props} className={cn('CheckboxTreeLayout', {}, className)}>
    <div className="CheckboxTreeLayout__header">{header}</div>
    {children && <div className="CheckboxTreeLayout__children">{children}</div>}
  </div>
)

export default CheckboxTreeLayout
